import React, { useState, useEffect } from "react";
import { supabase } from "../utils/supabaseClient";
import { Users } from "lucide-react";
import "../styles/VisitorStats.css";

const VisitorStats = () => {
  const [todayVisits, setTodayVisits] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTodayVisits = async () => {
      try {
        const today = new Date().toISOString().split("T")[0];
        const { data, error } = await supabase
          .from("page_visits")
          .select("visit_count")
          .eq("page_name", "home")
          .eq("visit_date", today)
          .single();

        if (error) {
          console.error("Error fetching visits:", error);
          return;
        }

        setTodayVisits(data?.visit_count || 0);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTodayVisits();
    // Refresh data every 5 minutes
    const interval = setInterval(fetchTodayVisits, 300000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="visitor-stats-card">
      <div className="visitor-stats-content">
        {loading ? (
          <div className="visitor-stats-loading">Loading...</div>
        ) : (
          <div className="visitor-stats-count">{todayVisits}</div>
        )}
        <div className="visitor-stats-label">
          <Users size={20} />
          <span>Today's Visitors</span>
        </div>
      </div>
    </div>
  );
};

export default VisitorStats;
